/*
# -----------------------------------------------------------------------------
# Component: paymentListMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 10/May/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const paymentListMixin = {
  data() {
    return {
      totalItems: 0,
      items: [],
      selectedPage: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedPaymentColumns: ['branch', 'accountNo', 'documentNo', 'tranDate', 'currency', 'amount', 'gst', 'bankOrigAmt', 'bankLocTot'],
      paymentColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Acct. No.', value: 'accountNo' },
        { text: 'Doc. No.', value: 'documentNo' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Currency', value: 'currency' },
        { text: 'Amount ', value: 'amount' },
        { text: 'GST', value: 'gst' },
        { text: 'Bank Amount', value: 'bankOrigAmt' },
        { text: 'Local Bank Amount', value: 'bankLocTot' }
      ],
      firstTimeCalling: true
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listPaymtHeaders() {
      let result = []
      for (const selectedPaymtColumn of this.selectedPaymentColumns) {
        let findCol = this.paymentColumns.find(a => selectedPaymtColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
